module.exports = __webpack_public_path__ + "img/plan-1-4.8179fc8b.png";